// src/components/SyncStatusIndicator.js
import React from 'react';
import { useSyncNeeded } from '../hooks/useSyncNotification';
import '../css/SyncStatusIndicator.css';

/**
 * Small indicator component that can be placed in sidebar or header
 * Shows a visual indicator when sync is needed
 */
const SyncStatusIndicator = ({ onClick, compact = false }) => {
  const { syncNeeded, urgency, isOverdue } = useSyncNeeded();
  
  if (!syncNeeded) {
    return null; // Don't show anything when sync is not needed
  }
  
  const getIndicatorIcon = () => {
    if (isOverdue) return '🚨';
    if (urgency === 'medium') return '⚠️';
    return '📊';
  };
  
  const getIndicatorText = () => {
    if (compact) {
      return isOverdue ? 'Sync!' : 'Sync';
    }
    
    if (isOverdue) return 'Energie sync vereist!';
    if (urgency === 'medium') return 'Energie sync reminder';
    return 'Maandelijkse sync beschikbaar';
  };
  
  return (
    <div 
      className={`sync-status-indicator ${urgency} ${compact ? 'compact' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : 'status'}
      tabIndex={onClick ? 0 : undefined}
      title={compact ? getIndicatorText() : undefined}
    >
      <span className="indicator-icon">{getIndicatorIcon()}</span>
      {!compact && (
        <span className="indicator-text">{getIndicatorText()}</span>
      )}
      <span className="pulse-dot"></span>
    </div>
  );
};

export default SyncStatusIndicator;